const TestStatuses = [
    { label: 'Draft', value: 'draft' },
    { label: 'Pretesting', value: 'pretesting' },
    { label: 'Queued for live', value: 'queued_for_live' },
    { label: 'Live', value: 'live' },
    { label: 'Sample', value: 'sample' },
    { label: 'Withdrawn', value: 'withdrawn' },
    { label: 'Archived', value: 'archived' },
    { label: 'Released', value: 'released' },
];

export default TestStatuses;